import React from "react";
import {
  ResponsiveContainer,
  ScatterChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Scatter,
} from "recharts";
import { randomColorPicker } from "../../../../../../../../../../utils/randomColorPicker";
import { chartDomainChecker } from "../../../../../../../../../../utils/chartDomainChecker";
import { VisualizationData } from "../../../types";

type Props = {
  chart: VisualizationData;
};

const CustomScatterChart = ({ chart }: Props) => {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <ScatterChart margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
        <CartesianGrid />
        <XAxis
          type="number"
          dataKey={chart.x_axis_name}
          name={chart.x_axis_name}
          domain={chartDomainChecker(chart.range.x_range)}
        />
        <YAxis
          type="number"
          dataKey={chart.y_axis_name}
          name={chart.y_axis_name}
          domain={chartDomainChecker(chart.range.y_range)}
        />
        <Tooltip cursor={{ strokeDasharray: "3 3" }} />
        <Scatter data={chart.data} fill={randomColorPicker()} />
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default CustomScatterChart;
